import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=3d3ea834&scoped=true&lang=html&"
import script from "./Notification.vue?vue&type=script&lang=coffee&"
export * from "./Notification.vue?vue&type=script&lang=coffee&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=3d3ea834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ea834",
  null
  
)

component.options.__file = "Notification.vue"
export default component.exports